import { FC } from 'react'

import { Pie, PieChart } from 'recharts'

export interface IProps {
    chartData: any
  width: number
}
const LearningStylePieChart: FC<IProps> = ({ chartData, width }) => {

  return (
    <PieChart width={width} height={width}>
    <Pie
      data={chartData}
      dataKey='value'
      nameKey='name'
      cx='50%'
      cy='50%'
      outerRadius={100}
      fill='fill'
    />
  </PieChart>
  )
}

export default LearningStylePieChart
